module.exports = __webpack_public_path__ + "static/img/总标题.e6afe9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/总标题.png
// module id = 8w3n
// module chunks = 0